import { Component, OnInit, OnDestroy } from '@angular/core';
import { Idle } from '@ng-idle/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-final-complete',
  templateUrl: './final-complete.component.html',
  styleUrls: ['./final-complete.component.scss']
})
export class FinalCompleteComponent implements OnInit {
  bodyUdate: HTMLElement;


  constructor(
    private idle: Idle,
    private router: Router 
  ) { 
    this.bodyUdate = document.getElementById('main-stage');
    this.bodyUdate.style.backgroundColor = 'rgba(40, 167, 69, 0.8)'
  }

  Done() {
    //Cancel extended profile
    this.router.navigate(['/scanticket']);
  }

  ScanAnother() {
    //Save extended profile
    this.router.navigate(['/scananother']);
  }

  ngOnInit() {
    if (!this.idle.isRunning()) {
      this.idle.watch();
    };
  }

  ngOnDestroy(){
    this.bodyUdate.style.backgroundColor = 'rgba(90, 25, 114, 0.8)';
  }

}



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/routes/final-complete/final-complete.component.ts